import { Col, Row } from "antd";
import React from "react";
import styled from "styled-components";
import { ReactComponent as Plus } from "../../../../assets/icons/PlusText.svg";
import { theme } from "../../../../theme";

interface Props {
  onClick?: (e: React.MouseEvent) => void;
  arrayLength: number;
}
const PlusTimeTextButton: React.FC<Props> = ({
  onClick,
  arrayLength,
  children,
}) => {
  return arrayLength === 30 ? null : (
    <Row
      gutter={[4, 0]}
      style={{ cursor: "pointer", width: "fit-content" }}
      wrap={false}
      onClick={onClick}
      align="middle"
    >
      <Col style={{ height: "32px" }}>
        <PlustIcon />
      </Col>
      <Col style={{ height: "32px", lineHeight: "32px" }}>
        <StyledText>{children || "시간 추가"}</StyledText>
      </Col>
    </Row>
  );
};
const StyledText = styled.span`
  ${theme.typo.body.r14};
  color: #5e3ff7;
  line-height: 32px;
`;
const PlustIcon = styled(Plus)`
  height: 32px;
`;
export default PlusTimeTextButton;
